export default __webpack_public_path__ + "static/media/5.f88c9515.png";